import { Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import Avatar from 'components/@extended/Avatar';
import { PopupTransition } from 'components/@extended/Transitions';
import { Logout } from 'iconsax-react';

interface Props {
  open: boolean;
  handleClose: (status: boolean) => void;
  handleConfirm: () => void;
}

export default function LogoutConfirmationModal({ open, handleClose, handleConfirm }: Props) {
  const handleCancel = () => {
    handleClose(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      keepMounted
      fullWidth
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="logout-confirmation-title"
      aria-describedby="logout-confirmation-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Stack alignItems="center" spacing={3.5}>
          <Avatar color="error" sx={{ width: 72, height: 72, fontSize: '1.75rem' }}>
            <Logout variant="Bold" />
          </Avatar>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
              Confirm Logout
            </Typography>
            <Typography align="center">Are you sure you want to log out?</Typography>
          </Stack>

          <Stack direction="row" spacing={2} sx={{ width: 1 }}>
            <Button fullWidth onClick={handleCancel} color="secondary" variant="outlined">
              Cancel
            </Button>
            <Button fullWidth color="primary" variant="contained" onClick={handleConfirm} autoFocus>
              Logout
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
